// extracted by mini-css-extract-plugin
module.exports = {"squareWrap":"Square_squareWrap_1_6rC","faTimes":"Square_faTimes_mBilH","faCircle":"Square_faCircle_266nf"};